import { render } from "./DeployModuleForm.vue?vue&type=template&id=06ece606"
import script from "./DeployModuleForm.vue?vue&type=script&lang=js"
export * from "./DeployModuleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__